import React from 'react';
import { Helmet } from 'react-helmet';
import { agencyStructuredData, servicesStructuredData } from '../data/structuredData';

const SEO = ({ 
  title = "Saldae Voyage | Agence de Voyage et d'Immigration à Béjaïa",
  description = "Saldae Voyage, votre agence de voyage et d'immigration à Béjaïa. Billetterie, voyages organisés, études à l'étranger, immigration au Canada et assistance visa.",
  image = "/social/og-image.jpg",
  url = "https://www.saldaevoyage.com",
  keywords = "agence voyage, immigration Canada, études étranger, visa, billetterie, Béjaïa, Algérie, voyages organisés"
}) => {
  return (
    <Helmet>
      {/* Balises SEO de base */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Saldae Voyage" />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Données structurées pour les moteurs de recherche */}
      <script type="application/ld+json">
        {JSON.stringify(agencyStructuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(servicesStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEO; 